<template>
  <p class=""><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.333008 0.5H13.0917C13.1501 0.499902 13.2075 0.515165 13.2582 0.544257C13.3089 0.57335 13.351 0.615251 13.3804 0.66576C13.4098 0.716269 13.4253 0.773612 13.4256 0.832041C13.4258 0.89047 13.4107 0.947932 13.3817 0.998667L10.9997 5.16667L13.3817 9.33467C13.4107 9.3854 13.4258 9.44286 13.4256 9.50129C13.4253 9.55972 13.4098 9.61707 13.3804 9.66757C13.351 9.71808 13.3089 9.75998 13.2582 9.78908C13.2075 9.81817 13.1501 9.83343 13.0917 9.83333H1.66634V13.1667H0.333008V0.5Z"
        :fill="row.evaluations.current.color" />
    </svg>
    {{row.evaluations.current.name}}</p>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "EstadoLegal",
  data() {
    return {
      selected: false
    }
  },
  props: ['row', 'field'],
  computed: {
    ...mapState("modTipshiftReport", ["tipshift", "selectAll"]),
    ...mapGetters([
      'modTipshiftReport',
      ["getAllSelected"]
    ]),
  },
  methods: {
    ...mapActions("modTipshiftReport", [
      "actSaveTipshift",
      "actGetTipshift",
      "actGetSelectAll",
      "actSelectRow",
      "actEliminarRegistroNovedad"
    ]),

    eliminarRegistroNovedad(id) {
      this.actEliminarRegistroNovedad(id);
    },

  },
};
</script>

<style lang="scss" scoped>
.icon-checkmark,
.icon-circle-clock,
.icon-warning {

  margin-right: 0.5rem;
}

.warning {
  color: #E66401;
}

.success {
  color: #00761A;
}

.span-icon {
  background: #F6FFED;
  border-radius: 8px;
  font-family: 'Ubuntu';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
}
</style>